<template>
  <el-dialog
    title="审批退款申请"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <!-- 退款申请信息 -->
    <el-descriptions :column="2" border>
      <el-descriptions-item label="退款单号">
        {{ formData.refund_no }}
      </el-descriptions-item>
      <el-descriptions-item label="订单号">
        {{ formData.order_no }}
      </el-descriptions-item>
      <el-descriptions-item label="订单金额">
        ¥{{ formatMoney(formData.order_amount) }}
      </el-descriptions-item>
      <el-descriptions-item label="退款金额">
        <span style="color: #F56C6C; font-weight: bold">
          ¥{{ formatMoney(formData.refund_amount) }}
        </span>
      </el-descriptions-item>
      <el-descriptions-item label="退款原因" :span="2">
        {{ formData.refund_reason }}
      </el-descriptions-item>
    </el-descriptions>

    <!-- 审批表单 -->
    <el-form
      ref="approveForm"
      :model="formData"
      :rules="rules"
      label-width="100px"
      style="margin-top: 20px"
    >
      <el-form-item label="审批结果" prop="approve_result">
        <el-radio-group v-model="formData.approve_result">
          <el-radio :label="1">
            <span style="color: #67C23A; font-weight: bold">通过</span>
          </el-radio>
          <el-radio :label="2">
            <span style="color: #F56C6C; font-weight: bold">拒绝</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="审批备注" prop="approve_remark">
        <el-input
          v-model="formData.approve_remark"
          type="textarea"
          :rows="4"
          placeholder="请填写审批意见"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <!-- 审批提示 -->
    <el-alert
      :title="formData.approve_result === 1 ? '审批通过后的操作' : '审批拒绝说明'"
      :type="formData.approve_result === 1 ? 'success' : 'warning'"
      :closable="false"
    >
      <div v-if="formData.approve_result === 1" style="font-size: 12px; line-height: 1.8">
        1. 系统将自动调用富友支付退款接口<br>
        2. 退款成功后，订单退款状态将更新为"已退款"<br>
        3. 如该订单已产生佣金，将自动扣减
      </div>
      <div v-else style="font-size: 12px; line-height: 1.8">
        1. 拒绝后，该退款申请状态将变更为"失败"<br>
        2. 订单退款状态将更新为"退款失败"<br>
        3. 用户需要重新发起退款申请
      </div>
    </el-alert>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button
        :type="formData.approve_result === 1 ? 'success' : 'danger'"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        {{ formData.approve_result === 1 ? '确认通过' : '确认拒绝' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { approveRefund } from '@/api/iccid-refund'
import { formatMoney } from '@/utils/iccid-formatter'

export default {
  name: 'RefundApproveDialog',
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      formData: {
        refund_no: '',
        order_no: '',
        order_amount: 0,
        refund_amount: 0,
        refund_reason: '',
        approve_result: 1,
        approve_remark: ''
      },
      rules: {
        approve_result: [
          { required: true, message: '请选择审批结果', trigger: 'change' }
        ],
        approve_remark: [
          { required: true, message: '请填写审批备注', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    formatMoney,
    open(refundData) {
      this.dialogVisible = true
      this.formData = {
        refund_no: refundData.refund_no,
        order_no: refundData.order_no,
        order_amount: refundData.order_amount,
        refund_amount: refundData.refund_amount,
        refund_reason: refundData.refund_reason,
        approve_result: 1,
        approve_remark: ''
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs.approveForm.resetFields()
    },
    async handleSubmit() {
      this.$refs.approveForm.validate(async valid => {
        if (!valid) return

        // 二次确认
        const confirmText = this.formData.approve_result === 1
          ? '确认通过此退款申请？系统将自动调用富友退款接口。'
          : '确认拒绝此退款申请？拒绝后用户需要重新发起申请。'

        try {
          await this.$confirm(confirmText, '确认操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })

          this.submitLoading = true
          await approveRefund({
            refund_no: this.formData.refund_no,
            approve_result: this.formData.approve_result,
            approve_remark: this.formData.approve_remark
          })

          this.$message.success('审批成功')
          this.handleClose()
          this.$emit('success')
        } catch (error) {
          if (error !== 'cancel') {
            this.$message.error(error.message || '审批失败')
          }
        } finally {
          this.submitLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
